import {
  CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_BEGIN,
  CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_SUCCESS,
  CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_FAILURE,
  CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { toast } from 'react-toastify';

export function addCustomDataMapping(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_BEGIN,
    });

    console.log('These are the args that are being passed in the custom data mapping api: ', args);
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/custom-data-mapping`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_SUCCESS,
              data: res.data,
            });
            toast.success('Mapping Created Successfully');
            resolve(res);
          } else {
            dispatch({
              type: CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddCustomDataMappingError() {
  return {
    type: CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_BEGIN:
      return {
        ...state,
        addCustomDataMappingPending: true,
        addCustomDataMappingError: null,
      };

    case CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_SUCCESS:
      return {
        ...state,
        addCustomDataMappingPending: false,
        addCustomDataMappingError: null,
        customDataMappings: [...state.customDataMappings, action.data],
      };

    case CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_FAILURE:
      return {
        ...state,
        addCustomDataMappingPending: false,
        addCustomDataMappingError: action.data.error,
      };

    case CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_DISMISS_ERROR:
      return {
        ...state,
        addCustomDataMappingError: null,
      };

    default:
      return state;
  }
}
